"use client";

import React, { createContext, useContext, useMemo } from "react";

import { StepDef, WizardDefinition } from "../wizard/wizard-types";

type FlowContextValue = {
  wizard: WizardDefinition;
  current: StepDef;
};

const FlowContext = createContext<FlowContextValue | undefined>(undefined);

type WizardContextProviderProps = Readonly<{
  wizard: WizardDefinition;
  current: StepDef;
  children: React.ReactNode;
}>;

function WizardContextProvider({
  wizard,
  current,
  children,
}: WizardContextProviderProps) {
  const value = useMemo(
    () => ({
      wizard,
      current,
    }),
    [wizard, current]
  );

  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>;
}

export default WizardContextProvider;

export function useWizard(): FlowContextValue {
  const ctx = useContext(FlowContext);
  if (!ctx) {
    throw new Error("useWizard must be used inside a <WizardContextProvider>");
  }
  return ctx;
}
